import { ArquivoService } from '../../service';
import { ArquivoUrl } from '../../type';
import { FileType } from '../../type/enum';
import {
  TransProgressKind,
  transientRequest,
  useTransProgress
} from '../transference-progress';
import { ArquivoEntityWithTemp } from './ArquivoComponent';

export const getUnaccentFileName = (fileName: string) => {
  return fileName.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

const arquivoUrlToArquivoEntity = (
  arquivoUrl: Omit<ArquivoUrl, 'dataCriacao' | 'urlAssinada'> & {
    dataCriacao?: string;
  },
  file: File,
  arquivoEntityId?: string,
  patches?: any
): ArquivoEntityWithTemp => {
  const entity = {
    domainEntity: arquivoEntityId ? { id: arquivoEntityId } : undefined,
    arquivo: {
      nome: getUnaccentFileName(file.name),
      mimeType: file.type,
      dataCriacao: arquivoUrl.dataCriacao || new Date().toISOString(),
      fullPath: arquivoUrl.fullPath
    },
    ...(!arquivoEntityId && {
      temporario: true,
      localFile: file
    })
  };

  updateEntityWithPatches(entity, patches);

  return entity;
};

export const updateEntityWithPatches = (entity, patches) => {
  if (!patches) {
    return;
  }
  Object.keys(patches).forEach(key => {
    if (
      entity[key] &&
      typeof entity[key] === 'object' &&
      typeof patches[key] === 'object'
    ) {
      updateEntityWithPatches(entity[key], patches[key]);
      return;
    }

    entity[key] = patches[key];
  });
};

export const getFileName = (entity: any, file: File) => {
  return (
    entity?.arquivo?.nome ||
    entity?.nome ||
    entity?.fileName ||
    entity?.name ||
    file.name
  );
};

export const ArquivoUtils = (service: ArquivoService, filePath: number) => ({
  arquivoUrlToArquivoEntity,
  getUnaccentFileName,

  downloadArquivo: async ({
    url,
    nome,
    mimeType
  }: {
    url: string;
    nome?: string;
    mimeType?: string;
  }) => {
    return service
      .receberArquivoDoServidor(
        url,
        useTransProgress(nome || 'Arquivo sem nome', TransProgressKind.DOWNLOAD)
      )
      .then(({ data }) => {
        return new Blob([data], {
          type: mimeType
        });
      });
  },
  saveFileToEntity: ({
    file,
    entityId,
    fileName,
    arquivoUrl,
    patches
  }: {
    file: File;
    fileName: string;
    entityId: string;
    arquivoUrl: ArquivoUrl;
    patches?: any;
  }) => {
    const configs = useTransProgress(fileName, TransProgressKind.UPLOAD);

    return service
      .enviarArquivoParaServidor(
        file,
        arquivoUrl.urlAssinada,
        transientRequest({
          ...configs,
          headers: {
            'Content-Type': file.type || FileType.BIN
          }
        })
      )
      .then(() => {
        return service.salvarArquivoEntity(
          entityId,
          arquivoUrlToArquivoEntity(arquivoUrl, file, entityId, patches),
          configs
        );
      });
  }
});
